import { ConfirmationActions, ConfirmationState } from '@/components/dialog/confirmation.store';
import { DialogActions, DialogState } from '@/components/dialog/form.store';
import { usePermissions } from '@/features/auth/access-control/context/PermissionsProvider';
import { QueryClient } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { AxiosInstance } from 'axios';
import { router } from '../router';
import { AuthContextType } from '../routes/__root';

export function RouterWithPerms({
  confirmationStore,
  dialogFormStore,
  client,
  queryClient,
  auth,
}: {
  confirmationStore: ConfirmationState & ConfirmationActions;

  dialogFormStore: DialogState & DialogActions;

  client: AxiosInstance;

  queryClient: QueryClient;

  auth: AuthContextType;
}) {
  const perms = usePermissions();

  return (
    <RouterProvider
      router={router}
      context={{
        confirmationStore,
        dialogFormStore,
        queryClient,
        client,
        perms,
        auth,
      }}
    />
  );
}
